import Vue from "vue";
import VueRouter from "vue-router";

// 告诉 vue 使用 vueRouter
Vue.use(VueRouter);

var router = new VueRouter({
    routes: [{
            path: '/',
            redirect: '/login'
        },
        {
            path: '*',
            component: resolve => require(['./404.vue'], resolve),
            meta: {
                title: '[404]您要访问的页面不存在',
                keepAlive: true,
                public: false,
                init: false,
            }
        },
        {
            path: "/login",
            component: resolve => require(['./pages/login/login.vue'], resolve),
            meta: {
                title: '登录',
                keepAlive: false,
                public: false,
                init: false,
            }
        },
        {
            path: "/authcode",
            component: resolve => require(['./pages/login/authcode.vue'], resolve),
            meta: {
                title: '钉钉授权',
                keepAlive: false,
                public: false,
                init: false,
            }
        },
        {
            path: "/demo",
            component: resolve => require(['./pages/demo/demo.vue'], resolve),
            meta: {
                title: '登录',
                keepAlive: false,
                public: false,
                init: false,
            }
        },
        {
            path: "/experienceH5",
            component: resolve => require(['./pages/web_app/experienceH5.vue'], resolve),
            meta: {
                title: '免费试用u8D',
                keepAlive: true,
                public: false,
                init: false,
                h5:true,
                empty: true
            }
        },
        {
            path: "/indexh5",
            component: resolve => require(['./pages/web_app/indexH5.vue'], resolve),
            meta: {
                title: 'u8D质量云平台',
                keepAlive: true,
                public: false,
                init: false,
                h5:true,
                empty: true
            }
        },
        {
            path: "/agreementH5",
            component: resolve => require(['./pages/web_app/agreementH5.vue'], resolve),
            meta: {
                title: '个人信息授权书',
                keepAlive: true,
                public: false,
                init: false,
                h5:true,
                empty: true
            }
        },
        {
            path: "/reg",
            component: resolve => require(['./pages/reg/reg.vue'], resolve),
            meta: {
                title: '注册',
                keepAlive: false,
                public: false,
                init: false,
            }
        },
        {
            path: "/user_signature_h5",
            component: resolve => require(['./pages/user_signature_h5/user_signature_h5.vue'], resolve),
            meta: {
                title: '电子签名',
                keepAlive: false,
                public: false,
                init: false,
                empty: true
            }
        },
        {
            path: "/index",
            component: resolve => require(['./pages/index/index.vue'], resolve),
            meta: {
                title: '首页',
                keepAlive: false,
                public: true,
                init: false,
                summary: true,
            },
            children: [
                {
                    path: "find_summary",
                    component: resolve => require(['./pages/find_task_summary/find_task_summary.vue'], resolve),
                    meta: {
                        title: '部门汇总',
                        keepAlive: false,
                        public: true,
                        init: true,
                        summary: true,
                    },
                },
                {
                    path: "solve_summary",
                    component: resolve => require(['./pages/solve_task_summary/solve_task_summary.vue'], resolve),
                    meta: {
                        title: '部门汇总',
                        keepAlive: false,
                        public: true,
                        init: true,
                        summary: true,
                    },
                },
                {
                    path: "my_task",
                    component: resolve => require(['./pages/my_task/my_task.vue'], resolve),
                    meta: {
                        title: '我的任务',
                        keepAlive: false,
                        public: true,
                        init: true,
                    },
                },
                {
                    path: "my_complete_task",
                    component: resolve => require(['./pages/my_task/my_task.vue'], resolve),
                    meta: {
                        title: '我的任务-已完成',
                        keepAlive: false,
                        public: true,
                        init: true,
                    },
                },
                {
                    path: "my_task_details",
                    component: resolve => require(['./pages/my_task_details/my_task_details.vue'], resolve),
                    meta: {
                        title: '我的任务详情',
                        keepAlive: false,
                        public: true,
                        init: true,
                    },
                },
                {
                    path: "messg_routes",
                    component: resolve => require(['./pages/messg_routes/messg_routes.vue'], resolve),
                    meta: {
                        title: '详情',
                        keepAlive: false,
                        public: true,
                        init: true,
                    },
                },
                {
                    path: "my_task_add",
                    component: resolve => require(['./pages/my_task_add/my_task_add.vue'], resolve),
                    meta: {
                        title: '新建报告',
                        keepAlive: false,
                        public: true,
                        init: true,
                    },
                },
                {
                    path: "solve_task",
                    component: resolve => require(['./pages/solve_task/solve_task.vue'], resolve),
                    meta: {
                        title: '解决问题',
                        keepAlive: false,
                        public: true,
                        init: true,
                    },
                },
                {
                    path: "solve_task_details",
                    name: "solve_task_details",
                    component: resolve => require(['./pages/solve_task_details/solve_task_details.vue'], resolve),
                    meta: {
                        title: '解决问题详情',
                        keepAlive: false,
                        public: true,
                        init: true,
                    },
                },
                {
                    path: "find_task_details",
                    name: "find_task_details",
                    component: resolve => require(['./pages/solve_task_details/solve_task_details.vue'], resolve),
                    meta: {
                        title: '发现问题详情',
                        keepAlive: false,
                        public: true,
                        init: true,
                    },
                },
                {
                    path: "my_task_detailsall",
                    name: "my_task_detailsall",
                    component: resolve => require(['./pages/solve_task_details/solve_task_details.vue'], resolve),
                    meta: {
                        title: '我的任务详情',
                        keepAlive: false,
                        public: true,
                        init: true,
                    },
                },
                {
                    path: "my_task_detailsall_hulk",
                    name: "my_task_detailsall_hulk",
                    component: resolve => require(['./pages/solve_task_details/solve_task_details.vue'], resolve),
                    meta: {
                        title: '我的任务详情',
                        keepAlive: false,
                        public: true,
                        init: true,
                    },
                },
                {
                    path: "find_task",
                    component: resolve => require(['./pages/find_task/find_task.vue'], resolve),
                    meta: {
                        title: '发现问题',
                        keepAlive: false,
                        public: true,
                        init: true,
                    },
                },
                {
                    path: "find_task_add",
                    component: resolve => require(['./pages/find_task_add/find_task_add.vue'], resolve),
                    meta: {
                        title: '新建问题',
                        keepAlive: false,
                        public: true,
                        init: true,
                    },
                },
                {
                    path: "mail_colleague",
                    component: resolve => require(['./pages/mail/mail.vue'], resolve),
                    meta: {
                        title: '通讯录-同事',
                        keepAlive: false,
                        public: true,
                        init: true,
                    },
                },
                {
                    path: "mail_partner",
                    component: resolve => require(['./pages/mail_partner/mail_partner.vue'], resolve),
                    meta: {
                        title: '通讯录-合作伙伴',
                        keepAlive: false,
                        public: true,
                        init: true,
                    },
                },
            ]
        },
        {
            path: "/user",
            component: resolve => require(['./pages/user/user.vue'], resolve),
            meta: {
                title: '用户',
                keepAlive: false,
                public: true,
                init: true,
            },
            children: [{
                    path: "user_center",
                    component: resolve => require(['./pages/user_center/user_center.vue'], resolve),
                    meta: {
                        title: '用户-个人中心',
                        keepAlive: false,
                        public: true,
                        init: true,
                    },
                },
                {
                    path: "user_set",
                    component: resolve => require(['./pages/user_set/user_set.vue'], resolve),
                    meta: {
                        title: '用户-密码重置',
                        keepAlive: false,
                        public: true,
                        init: true,
                    },
                },
                {
                    path: "user_signature",
                    component: resolve => require(['./pages/user_signature/user_signature.vue'], resolve),
                    meta: {
                        title: '用户-电子签名',
                        keepAlive: false,
                        public: true,
                        init: true,
                    },
                },
                {
                    path: "user_company",
                    component: resolve => require(['./pages/user_company/user_company.vue'], resolve),
                    meta: {
                        title: '用户-切换公司',
                        keepAlive: false,
                        public: true,
                        init: true,
                    },
                },
            ]
        },
    ]
})

export default router;


// WEBPACK FOOTER //
// ./src/routes.js